import { usePathname } from "@-/com.npmjs.expo-router";
import { useEffect } from "react";
import { setDiagnosticsRoute } from "#diagnostics-store";

/**
 * Mirrors the current expo-router pathname into the diagnostics store so every sample and
 * stall is tagged with the screen it happened on. Renders nothing; mount once under the root
 * router.
 */
export function DiagnosticsRouteObserver() {
  const pathname = usePathname();
  useEffect(() => {
    setDiagnosticsRoute(pathname);
  }, [pathname]);
  return null;
}
